<template>
  <el-drawer size="750px" :visible.sync="visible" direction="rtl" :with-header="false" :before-close="handleClose">
    <div class="change-password-container">
      <img src="../assets/login-logo.png" class="logo" alt="">
      <div class="space"></div>

      <el-card v-if="isLogin" class="reset-pass-user-card">
        <div class="member-header">
          <div class="member-info">
            <img src="../assets/avatar.png" class="member-avatar" alt="" />
            <div>
              <div class="member-name">Hi，{{ sessionUser.nickName }}</div>
              <div class="member-type-tag">{{ vips.packageName }}</div>
            </div>
          </div>
        </div>

        <div class="member-stats">
          <div class="stat-item">
            <span class="stat-value">{{ statistic.totalPoints }}</span>
            <span class="stat-label">积分</span>
          </div>
          <div class="stat-item">
            <span class="stat-value">{{ statistic.totalSignIn }}</span>
            <span class="stat-label">签到</span>
          </div>
          <div class="stat-item">
            <span class="stat-value">{{ statistic.totalInvite }}</span>
            <span class="stat-label">邀请</span>
          </div>
        </div>

        <div class="validity-info" :style="validityBgStyle">
          <span type="info" class="validity-tag">{{ vips.title }}</span>
          <div class="validity-days">
            <div class="remainingDays">{{ vips.remainDays >= 0 ? `剩余 ${vips.remainDays} 天` : '已过期' }}</div>
            <div class="expirationDate" v-if="vips.expireTime">有效期至 {{ vips.expireTime }}</div>
          </div>
        </div>
      </el-card>

      <div class="title">
          <span>修改密码</span>
      </div>
      <el-form ref="form" :model="user" :rules="rules" label-width="80px">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input class="form-input" v-model="user.oldPassword" placeholder="请输入旧密码" type="password" show-password>
            <template #prefix>
              <img src="../assets/icon-lock.png" alt="" class="pre-icon">
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input class="form-input" v-model="user.newPassword" placeholder="请输入新密码" type="password" show-password>
            <template #prefix>
              <img src="../assets/icon-lock.png" alt="" class="pre-icon">
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input class="form-input" v-model="user.confirmPassword" placeholder="请确认新密码" type="password" show-password>
            <template #prefix>
              <img src="../assets/icon-lock.png" alt="" class="pre-icon">
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="submit-btn" type="primary" size="mini" @click="submit">确认修改</el-button>
        </el-form-item>
      </el-form>

      <div class="notification" v-if="showSuccessMessage" :class="{ success: showSuccessMessage }">
        密码修改成功！
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { updateUserPwd } from '@/api'

export default {
  props: {
    resetDialogVisible: {
      default: false,
      require: true
    }
  },
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.user.newPassword !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      visible: this.resetDialogVisible,

      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      errors: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      showSuccessMessage: false,

      user: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      },
      // 表单校验
      rules: {
        oldPassword: [
          { required: true, message: "旧密码不能为空", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          { min: 6, max: 20, message: "长度在 6 到 20 个字符", trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { required: true, validator: equalToPassword, trigger: "blur" }
        ]
      }
    }
  },
  computed: {
    isLogin() {
      const raw = localStorage.getItem('user')
      if (!raw) return false
      let loginTime
      try {
        loginTime = JSON.parse(raw)?.loginTime
      } catch {
        return false
      }
      if (!loginTime) return false
      const active = new Date()
      active.setDate(active.getDate() - 15)
      return active < new Date(loginTime)
    },
    sessionUser() {
      try {
        return JSON.parse(localStorage.getItem('user')) || {}
      } catch {
        return {}
      }
    },
    vips() {
      try {
        return JSON.parse(localStorage.getItem('vips')) || {}
      } catch {
        return {}
      }
    },
    statistic() {
      try {
        return JSON.parse(localStorage.getItem('statistic')) || {}
      } catch {
        return {}
      }
    },
    validityBgStyle() {
      const bg = this.vips.background
      const url = bg || require('../assets/vipbg.png')
      return { backgroundImage: `url(${url})` }
    }
  },
  watch: {
    resetDialogVisible(val) {
      this.visible = val
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('update:resetDialogVisible', false)
      done();
    },
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          updateUserPwd(this.user.oldPassword, this.user.newPassword).then(response => {
            this.showSuccessMessage = true
            this.$message.success('修改成功')
            setTimeout(() => {
              this.$emit('updatePage', false)
            }, 3000)

          }).catch(err => {
            console.log(err)
          });
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.change-password-container {
  padding: 139px 108px 60px;
  height: 100%;
  position: relative;
  .logo {
    width: 250px;
    height: 54px;
  }
  .space {
    max-height: 160px;
    height: calc((100% - 520px)/2);
  }
}
.title {
  margin-bottom: 50px;
  span {
    display: inline;
    width: 100%;
    font-weight: 600;
    font-size: 24px;
    color: #666666;
    line-height: 33px;
    padding-bottom: 6px;
    cursor: pointer;

    margin-bottom: 20px;
    border-bottom: 4px solid #2683BE;
  }
}
.form-input {
  .pre-icon {
    margin-top: 21px;
    margin-left: 15px;
    width: 12px;
  }

  :deep(.el-input__inner) {
    height: 58px;
    padding-left: 50px;
  }
}
.submit-btn {
  background-color: transparent;
  border: 0;
  width: 100%;
  height: 111px;
  background-image: url('../assets/btn-bg.png');
  background-size: 100% 100%;
  font-size: 24px;
  color: #FFFFFF;
}
.notification {
  margin-top: 15px;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
}
.success {
  background-color: #d4edda;
  color: #155724;
}

.reset-pass-user-card {
  width: 100%;
  max-width: 324px;
  margin: 0 auto 32px;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  .member-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    position: relative;

    .member-info {
      flex: 1;
      display: flex;

      .member-avatar {
        width: 46px;
        height: 46px;
        margin-right: 8px;
        background: #fff;
      }

      .member-name {
        font-size: 16px;
        color: #081f4d;
        line-height: 22px;
      }

      .member-type-tag {
        font-size: 12px;
        color: #707172;
        line-height: 17px;
        margin-top: 4px;
      }
    }
  }

  .member-stats {
    display: flex;
    justify-content: space-around;
    padding: 15px;
  }

  .stat-item {
    text-align: center;
  }

  .stat-value {
    font-weight: 600;
    font-size: 14px;
    color: #1e2023;
    line-height: 20px;
    display: block;
  }

  .stat-label {
    font-size: 12px;
    color: #707172;
    line-height: 17px;
  }

  .validity-info {
    padding: 9px 10px;
    background-size: 100% 100%;
    width: 273px;
    height: 108px;
    max-width: 100%;
    margin: 0 auto 10px;
    box-sizing: border-box;
  }

  .validity-tag {
    margin-left: 33px;
    font-weight: 600;
    font-size: 12px;
    color: #4c535c;
    line-height: 17px;
  }

  .validity-days {
    width: 255px;
    max-width: 100%;
    height: 68px;
    background: #ffffff;
    border-radius: 10px;
    padding: 12px 18px;
    margin-top: 5px;
    box-sizing: border-box;

    .remainingDays {
      font-weight: bold;
      font-size: 16px;
      color: #000000;
      line-height: 22px;
    }

    .expirationDate {
      font-size: 12px;
      color: #999999;
      line-height: 17px;
      margin-top: 4px;
    }
  }
}
</style>
